import '@styles/pages/article.scss';

import { initCarousel } from '@molecules/carousel';
import { initOfferCard } from '@molecules/components/offer-card';
import { flickitySliderBySelector } from '@molecules/flickity-continuous-slider';
import { initSelectionBusHandler } from '@molecules/selection-bus-handler';
import { selectionSliderManager } from '@molecules/selection-slider-manager';

flickitySliderBySelector('.content-blocks__item--logos');
initCarousel();
initOfferCard();
initSelectionBusHandler();
selectionSliderManager();
